import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = {
    preventScroll: Boolean
  }

  connect() {
    // Initialize any setup needed
  }

  open() {
    const pageUrl = encodeURIComponent(window.location.href);
    const pageTitle = encodeURIComponent(document.title);

    // Add sharing URLs
    document.getElementById('facebookShare').setAttribute('href', `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`);
    document.getElementById('messengerShare').setAttribute('href', `fb-messenger://share?link=${pageUrl}`);
    document.getElementById('whatsappShare').setAttribute('href', `https://wa.me/?text=${pageTitle}%20${pageUrl}`);
    document.getElementById('emailShare').setAttribute('href', `mailto:?subject=${pageTitle}&body=${pageTitle}%0A${pageUrl}`);
    
    // Show dialog
    this.dialogTarget.showModal()
    
    if (this.preventScrollValue) {
      document.body.style.overflow = "hidden"
    }
  }

  close() {
    this.dialogTarget.close()
    
    if (this.preventScrollValue) {
      document.body.style.overflow = "visible"
    }
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  // Close with escape key
  disconnect() {
    this.close()
  }
}
